import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';
import { typography, colorSchemes } from './themePrimitives';
import { useMemo } from 'react';

interface AppThemeProps {
    children: React.ReactNode;
    disableCustomTheme?: boolean;
    themeComponents?: ThemeOptions['components'];
}

export default function AppTheme(props: AppThemeProps) {
    const { children, disableCustomTheme } = props;
    const theme = useMemo(() => {
        return disableCustomTheme
            ? {}
            : createTheme({
                cssVariables: {
                    colorSchemeSelector: 'data-mui-color-scheme',
                    cssVarPrefix: 'template',
                },
                colorSchemes,
                typography,
                components: {
                    MuiDialog: {
                        styleOverrides: {
                            paper: ({ theme }) => ({
                                backgroundColor: theme.palette.background.dialog,
                                backgroundImage: 'none',
                            }),
                        },
                    },
                    MuiMenu: {
                        styleOverrides: {
                            paper: {
                                backgroundImage: 'none',
                            },
                        },
                    },
                },
            });
    }, [disableCustomTheme]);

    if (disableCustomTheme) {
        return <React.Fragment>{children}</React.Fragment>;
    }

    return (
        <ThemeProvider theme={theme} disableTransitionOnChange noSsr defaultMode='dark'>
            {children}
        </ThemeProvider>
    );
}
